import {Organization, PaginatedOrganization} from '@app/modules/shared/models';

export interface IOrganizationState {
  organization: Organization;
  organizations: Organization[];
  paginatedOrganizations: PaginatedOrganization;
  success: string;
  error: string;
}

export const initialOrganizationState: IOrganizationState = {
  organization: null,
  organizations: [],
  paginatedOrganizations: null,
  success: '',
  error: ''
};
